export default {
    SET_CAMPAIGNS(state, campaigns) {
        state.campaigns = campaigns.items
        state.totalPages = campaigns.total_pages
    },
    ADD_CAMPAIGN(state, campaign) {
        state.campaigns.unshift(campaign)
    },
    UPDATE_CAMPAIGN(state, campaign) {
        const campaignIndex = state.campaigns.findIndex((u) => u.id === campaign.id)
        Object.assign(state.campaigns[campaignIndex], campaign)
    },
    DELETE_CAMPAIGN(state, campaignId) {
        const ItemIndex = state.campaigns.findIndex((u) => u.id === campaignId)
        state.campaigns.splice(ItemIndex, 1)
    },
    ADD_CAMPAIGN_INFOS(state, campaign) {
        state.campaignInfos = campaign
    }
}
